import { mapActions } from "vuex"
import dayjs from 'dayjs';
import NetworkJoinApplicationGrid from "./components/NetworkJoinApplicationGrid/NetworkJoinApplicationGrid.vue"
import AddNetworkJoinApplication from "./components/AddNetworkJoinApplication/AddNetworkJoinApplication.vue"

export default {
	components: { NetworkJoinApplicationGrid, AddNetworkJoinApplication },
	data() {
		return {
			showAddApplicationModal: false,
			rowData: {},
			search: "",
			period: [dayjs().startOf('year').format("YYYY-MM-DD"), dayjs().endOf('year').format("YYYY-MM-DD")],
			exportDisabled: false
		}
	},
	methods: {
		...mapActions(['getNetworkJoinApplications', 'setRefresh', 'setApplicationsFilter', 'exportNetworkJoinApplications']),
		onRowEdit(rowData) {
			this.rowData = { ...rowData }
			this.showAddApplicationModal = true
		},
		hendleSearchClick() {
			this.getNetworkJoinApplications({
				customerID: this.search
			})
		},
		exportToCSV() {
			this.exportDisabled = true;
			this.exportNetworkJoinApplications({
				customerID: this.search
			}).then(response => {
				const downloadLink = document.createElement("a");
				const blob = new Blob(["\ufeff", response.data]);
				const url = URL.createObjectURL(blob);
				downloadLink.href = url;
				downloadLink.download = "Applications.csv";
				document.body.appendChild(downloadLink);
				downloadLink.click();
				document.body.removeChild(downloadLink);
				this.exportDisabled = false;
			}, error => {
				console.log(error);
				this.exportDisabled = false;
			})

		},
	},
	watch: {
		showAddApplicationModal(val) {
			if (!val) {
				this.rowData = {}
			}
		},
		period(period) {
			this.setApplicationsFilter({
				from: period[0],
				to: period[1]
			})
			this.getNetworkJoinApplications({
				customerID: this.search
			})
		}
	}
}